export const GOOGLE_MAPS_CONFIG = {
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
  libraries: ['places'],
  language: 'en',
};
